import "../../../assets/presentation/components/modal-views/modal-view-renderer-DrOoOyIF.css";
import { useCoreDispatch, useCoreSelector } from "../../../redux/config.js";
import { selectAllModalViews } from "../../../redux/modal-view/selectors.js";
import { hideModalView } from "../../../redux/modal-view/thunks/hide-modal-view.js";
import { updateModalView } from "../../../redux/modal-view/thunks/update-modal-view.js";
import { retrieveModalView } from "./register-modal-view.js";
/* empty css                    */
import classNames from "classnames";
import { useRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/presentation/components/modal-views/modal-view-renderer.tsx
var ModalViewRenderer = ({ modalView, origin }) => {
	const dispatch = useCoreDispatch();
	const hide = async () => {
		await dispatch(hideModalView({ id: modalView?.id }));
	};
	const update = async () => {
		await dispatch(updateModalView({
			...modalView,
			id: modalView.id
		}));
	};
	const ModalComponent = retrieveModalView(modalView.component);
	if (!ModalComponent) return null;
	return ModalComponent({
		anchor: modalView.anchor,
		className: classNames({ visible: modalView?.isVisible }),
		component: modalView.component,
		constraint: modalView.constraint,
		id: modalView.id,
		hide,
		origin,
		update,
		key: modalView.id,
		...modalView.props
	});
};
var ModalViews = ({ className }) => {
	const modalViews = useCoreSelector(selectAllModalViews());
	const element = useRef(null);
	const origin = element?.current?.getBoundingClientRect() ?? {
		left: 0,
		top: 0
	};
	return /* @__PURE__ */ jsx("div", {
		className: classNames(className, "modal-views"),
		ref: element,
		children: modalViews?.map((modalView) => /* @__PURE__ */ jsx(ModalViewRenderer, {
			origin,
			modalView
		}, modalView.id))
	});
};
//#endregion
export { ModalViewRenderer, ModalViews };

//# sourceMappingURL=modal-view-renderer2.js.map